<template>
  <div>
    <div class="team-info-top">
      <img :src="imageSrc(bgImg)" alt="">
      <div class="topBtns">
        <!-- // 뒤로가기 -->
        <a>
          <button class="goBack" @click="goBack"></button>
        </a>
      </div>

      <div class="team-box">
        <div class="league" style="display: none">
          <span>{{ matchInfo.league_name_prt }}</span>
        </div>
        <div class="match">
          <div class="emblem">
            <img :src="getEmblem(matchInfo.home_team)" alt="">
            <p>{{matchInfo.home_team_full_name}}</p>
          </div>
          <div class="score home">{{matchInfo.home_team_goal}}</div>
          <div class="vs">
            <p class="top">K LEAGUE</p>
            <p class="title">VS</p>
            <p class="home">{{ matchInfo.type }}</p>
            <p class="date">{{ gameDate }}<span>({{matchInfo.game_yoil}})</span> <span class="time">{{matchInfo.game_time}}</span></p>
            <p class="stadium">@{{matchInfo.field_name}}</p>
          </div>
          <div class="score away">{{matchInfo.away_team_goal}}</div>
          <div class="emblem">
            <img :src="getEmblem(matchInfo.away_team)" alt="">
            <p>{{matchInfo.away_team_full_name}}</p>
          </div>
        </div>
        <div class="m-info">
          <p class="date">{{ gameDate }}<span>({{matchInfo.game_yoil}})</span></p>
          <p class="stadium">@{{matchInfo.field_name}}</p>
        </div>
        <div class="player">
          <ul v-if="homePlayerInfo">
            <li v-for="(home, index) in homePlayerInfo" :key="index"
                :class="{scroll: homePlayerInfo.length >= 4}">
              <img src="@/assets/img/icon/icon_ball.png" alt="">
              <p class="num">{{home.min}}’</p>
              <p class="name">{{home.name}}</p>
            </li>
          </ul>

          <ul v-if="awayPlayerInfo">
            <li v-for="(home, index) in awayPlayerInfo" :key="index">
              <img src="@/assets/img/icon/icon_ball.png" alt="">
              <p class="num">{{home.min}}’</p>
              <p class="name">{{home.name}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="high-light">
      <button @click="highlightAction">
        하이라이트
        <img src="@/assets/img/icon/icon_play.png" alt="">
      </button>
    </div>
  </div>
</template>

<script>
import {getEmblem, isEmpty} from '@/lib';
import {leagueName, oldLeagueName} from '@/lib/match';

export default {
  name : 'TeamInfo',
  components: {},
  props: {
    game: {
      type: Object,
      default: () => {
        return {}
      }
    },
    goal: {
      type: Array,
      default: () => {
        return []
      }
    },
    highlight: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      bgImg: 'match_detail',
      matchInfo: {},
      goalInfo: [],
      homePlayerInfo: [],
      awayPlayerInfo: [],
      highlightInfo: {},
      gameDate: '',
      gameId: '',
      meetSeq: '',
      meetYear: '',
    }
  },
  watch: {
    game: {
      handler: function () {
        this.setMatchInfo();
      },
      deep: true
    },
    goal: {
      handler: function () {
        this.goalInfo = this.goal;
        this.homePlayerInfo = [];
        this.awayPlayerInfo = [];
        this.setGoalInfo();
      },
      deep: true
    },
    highlight: {
      handler: function () {
        this.highlightInfo = this.highlight;
      },
      deep: true
    },
  },
  mounted () {
    // this.setMatchInfo();
  },
  methods: {
    getEmblem,
    setMatchInfo() {
      this.matchInfo = this.game;

      /*const gameDate = this.matchInfo.game_date.split('-');
      this.gameDate = gameDate[0] + '.' + gameDate[1] + '.' + gameDate[2];*/

      // eslint-disable-next-line no-unreachable
      const detailId = this.$route.params.id.split('_');
      this.meetYear = detailId[0];
      this.meetSeq = detailId[1];
      this.gameId = detailId[2];

      this.gameDate = this.matchInfo.game_date;
      this.matchInfo.game_time = this.matchInfo.game_time.slice(0,5);

      if(this.meetYear < 2013) {
        this.matchInfo.league_name = oldLeagueName(this.matchInfo.meet_seq, this.matchInfo.meet_name);
      } else {
        this.matchInfo.league_name = leagueName(this.matchInfo.meet_name);
      }

      if(this.matchInfo.league_name === 'facup') {
        this.matchInfo.league_name_prt = 'FA CUP';
      } else {
        this.matchInfo.league_name_prt = 'K LEAGUE';
      }

      if(this.matchInfo.home_team === 'K07') {
        this.matchInfo.type = '홈';
      } else {
        this.matchInfo.type = '어웨이';
      }
    },
    setGoalInfo() {
      this.goalInfo.map(item => {
        const obj = {
          name: item.player_info.replace(/[0-9]/g,''),
          min: null
        }
        if(item.play_half === '전반'){
          obj.min = Number(item.play_time);
        } else {
          obj.min = Number(item.play_time) + 45;
        }

        if(item.division === 'H') {
          this.homePlayerInfo.push(obj)
        } else {
          this.awayPlayerInfo.push(obj)
        }

      })
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/banner/'+imgSrc+'.png');
    },
    highlightAction() {
      this.$emit('highlight');
    },
    goBack() {
      const currentRoute = this.$route.name;
      // 특정 경로에 있을 때만 뒤로 가기를 막는 조건
      if (currentRoute === 'matchDetail') {
        this.$router.push({ name: 'matchList' });
      } else if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'matchList' });
      }
    }
  }
}
</script>
<style scoped>
.team-info-top .topBtns {
  z-index: 1;
}
</style>
